import request from '@/utils/request'

const orderApi = {
  createOrder: (data) => {
    return request({
      url: '/order/create',
      method: 'post',
      data
    })
  },
  queryCoupon: (params) => {
    return request({
      url: '/coupon/query',
      method: 'get',
      params
    })
  },
  queryAllCoupon: (params) => {
    return request({
      url: '/coupon/order/query',
      method: 'get',
      params
    })
  },
  queryCouponList: (params) => {
    return request({
      url: '/coupon/list',
      method: 'get',
      params
    })
  },
  getDictData: (params) => {
    return request({
      url: '/dictionary/get',
      method: 'get',
      params
    })
  },
  queryAllEcard: (params) => {
    return request({
      url: '/ecard/order/query',
      method: 'get',
      params
    })
  },
  queryEcardList: (params) => {
    return request({
      url: '/ecard/query',
      method: 'get',
      params
    })
  },
  queryOrderList: (params) => {
    return request({
      url: '/order/list',
      method: 'get',
      params
    })
  },
  queryOrderInfo: (orderId) => {
    return request({
      url: '/order/info/' + orderId,
      method: 'get'
    })
  },
  queryOrderInfoByNumber: (orderNumber) => {
    const params = {
      orderNumber: orderNumber
    }
    return request({
      url: '/order/query-number',
      method: 'get',
      params
    })
  },
    // 查询订单所有的物流轨迹信息
    getAllLogisticsTrack: (params) => {
      return request({
        url: '/order/logistics/track/query/all',
        method: 'get',
        params
      })
    },
  cancelOrder: (data) => {
    return request({
      url: '/order/cancel',
      method: 'post',
      data
    })
  },
  queryLogisticsInfo: (params) => {
    return request({
      url: '/order/logistics/query',
      method: 'get',
      params
    })
  },
  presetPayment: (data) => {
    return request({
      url: '/pay/preset',
      method: 'post',
      data
    })
  },
  queryWxpayStatus: (orderNumber, orderStatus) => {

    const params = {
      orderNumber: orderNumber,
      orderStatus: orderStatus,
      ts: (new Date()).getTime()
    }
    return request({
      url: '/pay/query-wx',
      method: 'get',
      params
    })
  },
  queryChinaumsPayStatus: (orderNumber, orderStatus) => {
    const params = {
      orderNumber: orderNumber,
      orderStatus: orderStatus,
      ts: (new Date()).getTime()
    }
    return request({
      url: '/pay/query-chinaums',
      method: 'get',
      params
    })
  }
}
export default orderApi
